export const COLOR_1 = '#F1618E';
export const COLOR_2 = '#F7A773';
